// extracted by mini-css-extract-plugin
export default {"root":"styles_root__2nHHC","dark":"styles_dark__LEyxS","logo":"styles_logo__C7ldv"};